import { notifySomething } from "../_Utils/AppDocuCommon";
import AppDocuServiceCall from "../_Utils/AppDocuServiceCall";
import React from "react";
import ServiceActivityDialogForm from "./_ServiceActivityDialogForm";

export default class AddServiceActivityDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      itemData: AddServiceActivityDialog.getInitialItemData(),
      loading: false,
    };
  }

  static getInitialItemData() {
    return {
      username: '',
      service_activity: '',
      service_provision: '',
      service_time: '',
      service_issue: '',
      service_desc: '',
      service_solution: '',
      car_brand: '',
      car_model: '',
      car_engine_code: '',
      car_notes: '',
      system_type: '',
      system_fuel: '',
      system_channel: '',
      system_brand: '',
      ecu_type: '',
      status: '',
    };
  }

  addService = async (itemData) => {
    this.setState({ loading: true });
    try {
      const res = await AppDocuServiceCall.createServiceActivity(itemData);
      if (res.data && res.data.is_valid === false) {
        notifySomething(res.data.message || 'Error adding item', 'error');
        this.setState({ loading: false });
        return;
      }
      await this.props.onItemsChange();
      this.props.onClose();
    } catch (error) {
      console.error('Error adding item:', error);
      notifySomething('Error adding item', 'error');
    }
    this.setState({ loading: false });
  };

  handleAdd = async () => {
    const m = this.state.itemData || {};
    const data = {
      ...m,
      username: m.username !== undefined && m.username !== null ? m.username : '',
      service_activity: m.service_activity !== undefined && m.service_activity !== null ? m.service_activity : '',
      service_provision: m.service_provision !== undefined && m.service_provision !== null ? m.service_provision : '',
      service_time: m.service_time !== undefined && m.service_time !== null ? m.service_time : '',
      service_issue: m.service_issue !== undefined && m.service_issue !== null ? m.service_issue : '',
      service_desc: m.service_desc !== undefined && m.service_desc !== null ? m.service_desc : '',
      service_solution: m.service_solution !== undefined && m.service_solution !== null ? m.service_solution : '',
      car_brand: m.car_brand !== undefined && m.car_brand !== null ? m.car_brand : '',
      car_model: m.car_model !== undefined && m.car_model !== null ? m.car_model : '',
      car_engine_code: m.car_engine_code !== undefined && m.car_engine_code !== null ? m.car_engine_code : '',
      car_notes: m.car_notes !== undefined && m.car_notes !== null ? m.car_notes : '',
      system_type: m.system_type !== undefined && m.system_type !== null ? m.system_type : '',
      system_fuel: m.system_fuel !== undefined && m.system_fuel !== null ? m.system_fuel : '',
      system_channel: m.system_channel !== undefined && m.system_channel !== null ? m.system_channel : '',
      system_brand: m.system_brand !== undefined && m.system_brand !== null ? m.system_brand : '',
      ecu_type: m.ecu_type !== undefined && m.ecu_type !== null ? m.ecu_type : '',
      status: m.status !== undefined && m.status !== null ? m.status : '',
    };
    // Call the service to add the item
    await this.addService(data);
  };

  componentDidUpdate(prevProps) {
    // Reset fields when dialog is opened
    if (this.props.isOpen && !prevProps.isOpen) {
      this.setState({ itemData: AddServiceActivityDialog.getInitialItemData() });
    }
  }

  render() {
    return (
      <ServiceActivityDialogForm
        itemData={this.state.itemData}
        onChange={itemData => this.setState({ itemData })}
        loading={this.state.loading}
        onSubmit={this.handleAdd}
        onClose={this.props.onClose}
        showUsername={true}
        title="Add New Service Activity"
        submitLabel="Add"
        disabled={false}
        open={!!this.props.isOpen}
        editMode={false}
      />
    );
  }
}
